import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {
  IListEditorTemplateComponent
} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/IListEditorTemplateComponent';
import {ITileViewSelection, IVirtualGridTile} from '@shared/interfaces/virtual-grid-tile';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommand} from '@shared/commands/command-base';
import {AnalyticReportHandler} from '@features/global-tax-calculator/services/analytic-report-handler';

@Component({
    standalone: false,
    selector: 'app-gtc-analytics-tile-list-component',
  templateUrl: './gtc-analytics-tile-list.component.html',
  styleUrls: ['./gtc-analytics-tile-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GtcAnalyticsTileListComponent implements  OnInit, IListEditorTemplateComponent, IVirtualGridTile {
  action: EventEmitter<any>;
  data: any;
  inputMetadata: any;
  invalidateSubject: InvalidateSubject;
  itemSelectionChanged: EventEmitter<ITileViewSelection>;
  title: string;
  valueChanged: EventEmitter<any>;

  hasPermission: boolean = false;

  constructor(private handler: AnalyticReportHandler) { }

  ngOnInit(): void {
    const val = this.handler.magicLinkModel.fieldValues['HasArchivePermission'];
    this.hasPermission = val === true || val?.toString().toLowerCase() === 'true';
  }

  onClick($event) {
    var [commandName,commandApi] = this.getCommandNameAndApi();
    const command = new PlatformCommand(commandName, commandApi);
    command.fieldValues['RelativePath'] = this.data.cells['ReportFileName'].value;
    command.fieldValues['ReportId'] = this.data.cells['DisplayId'].value;
    command.fieldValues['ReportDisplayName'] = this.data.cells['Name'].value;
    command.fieldValues['DefaultGraphId'] =  this.data.cells['DefaultGraphId'].value;
    command.fieldValues['CurrentSchemaAndReportVersion'] =   this.data.cells['CurrentSchemaAndReportVersion'].value;
    command.fieldValues['ViewMode'] =  this.data.cells['DefaultViewMode'].value;
    command.fieldValues['AnalyticReportModelId'] = this.data.id;
    this.handler.executeCommand(command);
  }

  getCommandNameAndApi():[string,string] {
    var command = this.handler.magicLinkModel.additionalCommands['DisplayId'] as PlatformCommand;
    const api = !command.api ? 'FileStoreApi' : command.api;
    return [command.name, api];
  }

  onMenuClick(e: any) {
    e.stopPropagation();
  }

  onActionClick(action: string) {
    this.handler.archiveReport(this.data, action === 'Archive');
  }
}
